import { useOutletContext } from 'react-router-dom'

import { GroupsDataCollection } from 'modules/expenses/components/groups/DataCollection'
import { GroupsDataTable } from 'modules/expenses/components/groups/DataTable'
import { TabRouteContextParams } from 'modules/expenses/lib/RouteContextParams'
import { useExpenses } from 'modules/expenses/pages/ExpensesContext'

const GroupsListTab = () => {
  const { employeeIds } = useOutletContext<TabRouteContextParams>()
  const {
    featureAvailabilities: { dataCollectionEnabled },
  } = useExpenses()

  return dataCollectionEnabled ? (
    <GroupsDataCollection employeeIds={employeeIds} />
  ) : (
    <GroupsDataTable employeeIds={employeeIds} />
  )
}

export default GroupsListTab
